import TicketHttp from "../../ticketHttp";

class ApprovalsServices {
  
  // Create new purchase cost
  static async updateApproval(data) {
    return TicketHttp.update('/approval/updateUserApproval', data);
  }

  static async getApproval(data) {
    return TicketHttp.post('/approval/getApproval',data);
  }

  static async getApprovedApproval(data) {
    return TicketHttp.post('/approval/getApprovedApproval',data);
  }


 
}

export default ApprovalsServices;
